{
  "Seguimiento del pedido": "Rastreamento do pedido",
  "Enviado": "Enviado",
  "Empaquetado": "Embalado",
  "Recibido": "Recebido",
  "Items del pedido": "Itens do pedido",
  "En proceso": "Em processamento",
  "Devolución solicitada": "Devolução solicitada",
  "Devolución en proceso": "Devolução em curso",
  "Devuelto": "Devolvido",
  "Envío": "Envio",
  "Devolución": "Devolução",
  "Ver en tienda": "Ver na loja",
  "Solicitudes de devolución": "Solicitações de devolução",
  "Envíos": "Envios",
  "Confirmado": "Confirmado",
  "En curso": "Em andamento",
  "Seguimiento de envío": "Rastreamento de remessa",
  "Destino": "Destino",
  "Dirección destino": "Endereço de destino",
  "Última actualización": "Última atualização",
  "Devolución pendiente": "Devolução pendente",
  "Recogida solicitada": "Coleta solicitada",
  "Devolución enviada": "Devolução enviada",
  "Entrega estimada": "Entrega estimada",
  "Valora tu experiencia con nosotros": "Avalie sua experiência conosco",
  "¡Gracias!": "Obrigado!",
  "Mensaje de alerta": "Mensagem de alerta",
  "Punto de recogida": "Ponto de recolha",
  "Mostrar historial completo": "Mostrar histórico completo",
  "Ocultar historial": "Ocultar histórico",
  "¿Necesitas hacer una devolución o cambio?": "Precisa de devolver ou trocar algo?",
  "¿Quieres devolver algo más?": "Quer devolver mais alguma coisa?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Devolva ou troque o seu artigo em poucos passos simples.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Inicie o processo em poucos passos. Vamos guiá-lo durante todo o processo.",
  "Abrir el portal de devoluciones": "Abrir o portal de devoluções",
  "Enviando": "A enviar",
  "¡Página no encontrada!": "Página não encontrada!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Lamentamos, mas não foi possível encontrar a página que procurava",
  "Puedes volver al ": "Pode voltar ao ",
  "principio": "início",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "ou escrever-nos para support@reveni.io se não encontrar o que procurava"
}
